import React from 'react';
import Header from '../components/Header';
import { Box, useTheme, useMediaQuery } from '@mui/material';

interface MainLayoutProps {
  children: React.ReactNode;
}

const drawerWidth = 240;

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  return (
    <Box sx={{ 
      background: '#f5f5f5', 
      minHeight: '100vh',
      overflow: 'hidden'
    }}>
      <Header />
      <Box sx={{ 
        pt: isMobile ? 8 : 2, 
        pl: isMobile ? 2 : `${drawerWidth + 16}px`, 
        pr: 2,
        pb: 2,
        transition: 'padding-left 0.3s', 
        maxWidth: 1200, 
        margin: '0 auto',
        minHeight: 'calc(100vh - 32px)',
        overflow: 'auto'
      }}>
        {children}
      </Box>
    </Box>
  );
};

export default MainLayout; 